import Env from "@/common/Env";

export default {
  adminApiServerUrl: (() => {
    if (Env.isLocal()) {
      return "http://localhost:4000";
    } else if (Env.isStaging()) {
      return "https://remocon-api-dev.blip.kr";
    } else if (Env.isProduction()) {
      return "https://remocon-api.blip.kr";
    }

    throw new Error("지원하지 않는 환경입니다.");
  })(),
  homepageUrl: Env.isProduction() ? "https://www.blip.kr" : "https://www-dev.blip.kr",
  missionUrl: Env.isProduction() ? "https://mission.blip.kr" : "https://mission-dev.blip.kr",
  quizUrl: Env.isProduction() ? "https://quiz.blip.kr" : "https://quiz-dev.blip.kr",
  blipSchema: Env.isProduction() ? "blip://" : "blipdev://",
  imageServerUrl: Env.isProduction() ? "https://image.blip.kr/v1/file/" : "https://image-dev.blip.kr/v1/file/",
  blipApiServerUrl: Env.isProduction() ? "https://api.blip.kr" : "https://api-dev.blip.kr",
  sharePageUrl: Env.isProduction() ? "https://s.blip.kr" : "https://share-dev.blip.kr",
  iframeUrl: "https://dqkxmq6c2zbrl.cloudfront.net/image.html?imageUrl=",
  blipUserId: Env.isProduction() ? "ck5yxegdp2m070km" : "ck7y6x43v00033i1",
};
